import { Component, Input, Output, EventEmitter, Inject} from 'ng-metadata/core';
import './collection-search.component.scss';

/**
 * @ngdoc directive
 * @name mwCollectionSearch
 * @module mw.components.collection
 *
 * @param {boolean} [is-search-active=false] Control if search field is active, default value is false.
 * @param {string} [search-input-placeholder='Find'] Placeholder text.
 * @param {string} [search-text] Search text.
 * @param {expression} [on-search] Angular expression to evaluate when a search has been triggered, $event is the search text.
 * @param {expression} [on-search-toggle] Angular expression to evaluate when search toggle button has been clicked, $event is a boolean indicating active(true)/inactive(inactive) state.
 *
 * @description
 * `<mw-collection-search>` is a component used for searching on items in a data table.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-collection-search is-search-active="$ctrl.isSearchActive" on-search-toggle="$ctrl.toggleSearch($event)" search-input-placeholder="Find Users" on-search="$ctrl.handleSearch($event)"></mw-collection-search>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-collection-search',
    template: `
        <md-button class="mw-collection-search__show-search-button md-icon-button" ng-click="$ctrl.showSearch($event)" aria-label="{{'mw-collection-search__find' | translate}}" ng-if="!$ctrl.isSearchActive">
            <md-tooltip md-delay="500"><span translate='mw-collection-search__find'></span></md-tooltip>
            <mw-icon svg-icon="action:ic_search_24px"></mw-icon>
        </md-button>
        <md-button class="mw-collection-search__search-button md-icon-button" aria-label="{{'mw-collection-search__find' | translate}}" ng-click="$ctrl.handleSearch($event)" ng-if="$ctrl.isSearchActive">
            <md-tooltip md-delay="500"><span translate="mw-collection-search__find"></span></md-tooltip>
            <mw-icon svg-icon="action:ic_search_24px"></mw-icon>
        </md-button>
        <md-input-container class="mw-collection-search__search-input-container md-block" md-no-float ng-if="$ctrl.isSearchActive" flex-xs>
            <input id="mw-dashboards-table__search-input" class="mw-collection-search__search-input" ng-model="$ctrl.searchText" type="text" placeholder="{{$ctrl.searchInputPlaceholder}}" ng-keypress="$ctrl.onSearchKeypress($event)">
        </md-input-container>
        <md-button class="mw-collection-search__cancel-search-button md-icon-button" aria-label="{{'mw-collection-search__cancel-find' | translate}}" ng-click="$ctrl.cancelSearch($event)"  ng-if="$ctrl.isSearchActive">
            <md-tooltip md-delay="500"><span translate="mw-collection-search__cancel-find"></span></md-tooltip>
            <mw-icon svg-icon="navigation:ic_close_24px"></mw-icon>
        </md-button>
    `
})
export class CollectionSearchComponent {
    @Input('<') isSearchActive: boolean = false;
    @Input('@') searchInputPlaceholder: string = 'Find';
    @Input('@') searchText: string;
    @Output() onSearch = new EventEmitter<string>();
    @Output() onSearchToggle = new EventEmitter<boolean>();

    constructor(@Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$window') private $window: ng.IWindowService) {
        'ngInject';
    }

    handleSearch() {
        this.onSearch.emit(this.searchText);
    }

    onSearchKeypress(ngKeypressEvent: KeyboardEvent) {
        if (ngKeypressEvent.which === 13) {
            this.handleSearch();
        }
    }

    showSearch() {
        this.toggleSearchVisibility(true);
        this.$timeout(() => {
            let element = this.$window.document.getElementById('mw-dashboards-table__search-input');
            if (element) {
                element.focus();
            }
        });
    }

    toggleSearchVisibility(isSearchActive: boolean) {
        this.onSearchToggle.emit(isSearchActive);
    }

    cancelSearch() {
        this.toggleSearchVisibility(false);
        this.searchText = '';
        this.handleSearch();
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/collection/collection-search/collection-search.component.ts